import { useEffect } from 'react';
import { CheckCircle, ExternalLink } from 'lucide-react';
import { providersByType, typeInfo } from '../providerConfig';
import type { StepProps } from '../types';

export function ProviderStep({ data, onChange, onValidChange }: StepProps) {
  const providers = providersByType[data.type];
  const info = typeInfo[data.type];

  useEffect(() => {
    onValidChange(!!data.provider);
  }, [data.provider, onValidChange]);

  const handleSelect = (provider: typeof data.provider) => {
    onChange({
      provider,
      config: {},
    });
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
          Selecciona un proveedor de {info.label}
        </h3>
        <p className="text-sm text-gray-500 dark:text-gray-400">
          Cada proveedor tiene diferentes características y precios. Puedes configurar múltiples con fallback automático.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-3">
        {providers.map((p) => {
          const isSelected = data.provider === p.provider;

          return (
            <button
              key={p.provider}
              type="button"
              onClick={() => handleSelect(p.provider)}
              className={`relative p-4 border-2 rounded-xl text-left transition-all ${
                isSelected
                  ? 'border-brand-500 bg-brand-50 dark:bg-brand-900/20'
                  : 'border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600'
              }`}
            >
              <div className="flex items-start justify-between gap-4">
                <div>
                  <div className="flex items-center gap-2">
                    <span className={`font-semibold ${
                      isSelected
                        ? 'text-brand-700 dark:text-brand-300'
                        : 'text-gray-800 dark:text-white'
                    }`}>
                      {p.name}
                    </span>
                  </div>
                  <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                    {p.description}
                  </p>
                </div>
                <div className="flex items-center gap-2">
                  {isSelected && (
                    <CheckCircle className="w-5 h-5 text-brand-500" />
                  )}
                </div>
              </div>
            </button>
          );
        })}
      </div>

      <div className="p-4 bg-gray-50 dark:bg-gray-800/50 rounded-lg">
        <p className="text-sm text-gray-600 dark:text-gray-400">
          <strong>Tip:</strong> Puedes configurar múltiples proveedores del mismo tipo para tener fallback automático si uno falla.
        </p>
      </div>
    </div>
  );
}
